<template>
    <section
        v-if="comments"
        class="comments"
        id="comments"
    >
        <comment-composer
            :placeholder="`Join the conversation`"
        />
        <transition-group
            v-bind:name="initialSetDone ? 'comments-list' : 'none'"
            tag="ul"
            class="comments__list"
        >
            <li
                v-for="comment in comments"
                :key="comment.id"
                class="comments__listItem"
            >
                <comment :comment="comment"/>
            </li>
        </transition-group>
        <comment-remove-modal />
        <comment-flag-modal />
    </section>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import CommentComposer from './CommentComposer.vue';
import Comment from './Comment.vue';
import CommentRemoveModal from './CommentRemoveModal.vue';
import CommentFlagModal from './CommentFlagModal.vue';

export default {
    name: 'Comments',
    components: {
        Comment,
        CommentComposer,
        CommentRemoveModal,
        CommentFlagModal,
    },
    props: {
        articleId: {
            type: Number,
            required: true,
        },
    },
    computed: {
        ...mapState('comments', ['comments', 'initialSetDone']),
    },
    mounted() {
        this.getComments();
        this.setArticleId(this.articleId);
    },
    methods: {
        ...mapActions('comments', ['setComments', 'addComment', 'setArticleId']),
        getComments() {
            axios.get('/api/comments', {
                params: {
                    commentable_type: 'Article',
                    commentable_id: this.articleId,
                },
            }).then((response) => {
                this.setComments(response.data.data);
            }).catch((error) => {
                console.log('Error retrieving comments:', error);
            });
        },
    },
};
</script>

<style lang="scss">
    .comments-list-enter-active, .comments-list-leave-active,
    .comments-list-enter-active .comment__body {
        transition: all 0.6s 0.3s;
    }
    .comments-list-move {
        transition: transform 0.6s;
    }
    .comments-list-enter, .comments-list-leave-to {
        opacity: 0;
        transform: translateY(-1.5rem);
    }
    .comments-list-enter .comment__body {
        background-color: hsl(209, 53%, 50%);
    }
</style>
